import React from "react"
import styled from "styled-components"
import Link from "gatsby-link"

import { Settings } from "../../../styles/theme"

const Dropdownstyle = styled.div`
  position: absolute;
  z-index: 5;
  top: 0;
  left: 50%;
  transform: translate(-50%, 2.7rem);
  background: #fff;
  width: 10rem;
  padding: 1rem;
  a {
    display: block;
    padding: 0.5rem 0;
    transition: color 125ms ease-in-out;
    &:hover {
      color: ${Settings.primaryColor} !important;
    }
  }
`

export const Dropdown = ({ data }) => (
  <Dropdownstyle>
    {data.map((link, i) => {
      return /^(http|https):/.test(link.slug) !== true ? (
        <Link to={link.slug} key={i}>
          {link.title}
        </Link>
      ) : (
        <a href={link.slug} key={i} target="_blank">
          {link.title}
        </a>
      )
    })}
  </Dropdownstyle>
)
